import { useGetFacilityServices } from './useGetFacilityServices';

const defaultLabels = {
  appointments: 'Update History',
  newAppointment: 'New Appointment',
  createAppointment: 'Create Appointment',
  createNewAppointment: 'Create New Appointment',
  appointmentSuccessfullyCreated: 'Appointment Successfully Created',
  viewAppointments: 'View Appointments',
  noAppointments: 'No Appointments',
  appointmentType: 'Appointment Type',
  appointmentDate: 'Appointment Date',
  appointmentTime: 'Appointment Time',
  trackingBoard: 'Update Board',
  ptbPhaseFilterHideHelper:
    'Select Phases to hide from the Update Board display',
  addToTrackingBoard: 'Add Pet to Update Board',
  addedToTrackingBoard: 'added to the Update Board',
  couldNotAddToTrackingBoard: 'Could not add to Update Board',
  alreadyOnTrackingBoardToday: 'is already on the Update Board today.',
  trackingBoardStatusUpdateTitle: 'Status Update',
  copyHistory: 'Copy History',
  viewStatusHistoryTitle: 'View Update History',
};

const boardingLabels = {
  appointments: 'Photo Update History',
  newAppointment: 'New Stay',
  createAppointment: 'Create Stay',
  createNewAppointment: 'Create New Stay',
  appointmentSuccessfullyCreated: 'Stay Successfully Created',
  viewAppointments: 'View Stays',
  noAppointments: 'No Stays',
  appointmentType: 'Stay Type',
  appointmentDate: 'Stay Date',
  appointmentTime: 'Stay Time',
  trackingBoard: 'Photo Update Board',
  ptbPhaseFilterHideHelper:
    'Select Phases to hide from the Photo Update Board display',
  addToTrackingBoard: 'Add Pet to Photo Update Board',
  addedToTrackingBoard: 'added to the Photo Update Board',
  couldNotAddToTrackingBoard: 'Could not add to the Photo Update Board',
  alreadyOnTrackingBoardToday: 'is already on the Photo Update Board today.',
  trackingBoardStatusUpdateTitle: 'Update',
  copyHistory: 'Copy History',
  viewStatusHistoryTitle: 'View Photo Update History',
};

export function getAppointmentLabels(isBoardingOnly) {
  return isBoardingOnly ? boardingLabels : defaultLabels;
}

export function useAppointmentLabels() {
  const { data: services } = useGetFacilityServices();
  return getAppointmentLabels(!!services?.isBoardingOnly);
}
